<template>
  <q-menu
    :class="menuClass"
    v-bind="$attrs"
    transition-show="jump-down"
    transition-hide="jump-up"
  >
    <slot />

    <q-list v-if="listItems.length" dense v-bind="listOptions">
      <q-item
        v-for="item in listItems"
        v-close-popup
        clickable
        :to="item?.to && item.to"
        @click="item.onClick && item.onClick()"
      >
        <!-- Optional: an item without an icon renders exactly as it did before. -->
        <q-item-section v-if="item.icon !== undefined" avatar class="c-menu__icon">
          <q-icon :name="item.icon" size="18px" />
        </q-item-section>

        <q-item-section>{{ item.label }}</q-item-section>
      </q-item>
    </q-list>
  </q-menu>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  listOptions: {
    type: Object,
    required: false,
  },
  listItems: {
    type: Array,
    required: false,
    default: () => [],
  },
  // Drops the menu's own surface (background, border, shadow) so only the
  // slotted content shows, e.g. the stacked badges of an expandable CBadge.
  // Important, because the global `.q-menu[role="menu"]` override outranks
  // plain utilities.
  bare: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const menuClass = computed(() =>
  props.bare
    ? "!tw-rounded-none !tw-border-0 !tw-bg-transparent !tw-shadow-none"
    : "tw-rounded-lg tw-border tw-border-gray-200 !tw-shadow-lg",
);
</script>

<style lang="scss">
.q-list {
  @apply tw-py-2;

  &.q-list--dense > .q-item,
  .q-item--dense {
    min-height: 38px;
  }
}

// Quasar reserves 56px for an avatar section, which is a portrait's worth of space next to
// a menu label. These are single icons, so the column is only as wide as the glyph.
.c-menu__icon {
  @apply tw-text-gray-500;

  min-width: 0;
  padding-right: 12px;
}

div.q-menu {
  @apply tw-overscroll-contain;
}
</style>
